<div class="flex flex-column" style="height: calc(100vh - 100px);">
  <div class="flex flex-column card p-4">
    <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between mb-1">
      <p *ngIf="synoptic" class="inline-block mb-1 text-4xl flex-order-1 sm:flex-order-0">
        {{'model.synoptic' | transloco}} {{synoptic.name}}
      </p>
      <p-skeleton *ngIf="!synoptic" class="w-18rem flex-order-1 sm:flex-order-0 mb-1" height="41.99px"></p-skeleton>
      <div class="flex-order-0 sm:flex-order-1">
        <button
          *ngIf="'ROLE_OPERATOR' | userHasRole"
          [label]="'common.edit' | transloco"
          [state]="{ fromRoute: 'synoptics/' + synoptic?.uuid + '/details' }"
          [disabled]="!synoptic"
          [loading]="!synoptic"
          pButton
          pRipple
          class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
          routerLink="../edit"
          icon="pi pi-pencil"
        ></button>
      </div>
    </div>
    <div>
      <ng-container *ngIf="synoptic">
        <p *ngIf="synoptic.description">
          <b>{{'attribute.description' | transloco}}: </b>{{synoptic.description}}
        </p>
        <p *ngIf="!synoptic.description" class="font-italic">
          {{'empty.description' | transloco}}
        </p>
      </ng-container>
      <p-skeleton *ngIf="!synoptic" styleClass="w-19rem sm:w-25rem" height="21.01px"></p-skeleton>
    </div>
  </div>
  <div class="card flex-grow-1" style="margin-top: 1px;">
    <app-synoptic-visualization
      *ngIf="synoptic"
      [synopticConfiguration]="synoptic.configuration"
      [synopticFiles]="synoptic.files"
    ></app-synoptic-visualization>
    <div *ngIf="!synoptic" class="w-full h-full fadein">
      <p-skeleton height="100%"></p-skeleton>
    </div>
  </div>
</div>
